
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/compare",
      function () {
        return require("private-next-pages/properties/compare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/compare"])
      });
    }
  